import React from "react"
import {Button} from "@mui/material"

// Labelled with the customer so the button says who it assigns, rather than
// leaving a page of identical "Assign" buttons.
function AssignButton({name, onAssign, disabled}: {name: string; onAssign: () => void; disabled: boolean}) {
	return (
		<Button size="small" variant="outlined" onClick={onAssign} disabled={disabled} aria-label={`Assign ${name}`}>
			Assign
		</Button>
	)
}

export {AssignButton}
